// extracted by mini-css-extract-plugin
export var genericContainer = "_404-module--genericContainer--d2d8d";
export var gridContainer = "_404-module--gridContainer--53f49";
export var gridStaticContainer = "_404-module--gridStaticContainer--54b31";
export var imageContainer = "_404-module--imageContainer--340c8";
export var textContainer = "_404-module--textContainer--2fa1e";
export var title = "_404-module--title--99db8";